import { Variant } from 'react-bootstrap/types';
import { TransportOrder } from '../../domain/transportOrder';
import { TransportOrderFeedStatus } from '../../domain/transportOrdersFeed';

export const statuses: {
    [status in TransportOrderFeedStatus]: {
        label: string,
        variant: Variant,
        updateToStatus?: { status: TransportOrder['status'] }
    }
} = {
    toLoad: {
        label: 'Potwierdź załadunek',
        variant: 'warning',
        updateToStatus: {
            status: 'LOADED',
        },
    },
    loaded: {
        label: 'Załadowane',
        variant: 'primary',
    },
    toUnload: {
        label: 'Potwierdź rozładunek',
        variant: 'warning',
        updateToStatus: {
            status: 'UNLOADED',
        },
    },
    unloaded: {
        label: 'Rozładowane',
        variant: 'primary',
    },
    toUnloadAndNotYetLoaded: {
        label: 'Potwierdź rozładunek',
        variant: 'danger',
        updateToStatus: {
            status: 'UNLOADED',
        },
    },
};
